import { FSFileList, mapFSFileLists } from "../FileList";

/* **************************************************** Finishing Shedule Floor Finishing */
export interface FSFloorFinishing {
    id: number;
    fs_feature_id: number;
    location_id: number | null;
    type_id: number | null;
    brand_id: number | null;
    name: string | null;
    note: string | null;
    link: string | null;
    image_path: string | null;
    file_list: FSFileList[];
}

export const mapFSFloorFinishing = (data: any): FSFloorFinishing => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSFloorFinishing = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        location_id: data.location_id || null,
        type_id: data.type_id || null,
        brand_id: data.brand_id || null,
        name: data.name || null,
        note: data.note || null,
        link: data.link || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
    };

    return res;
};

export const mapFSFloorFinishings = (data: any[]): FSFloorFinishing[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSFloorFinishing);
};
